import { z } from 'zod'

import { schemas } from '~interface/zod-schema'

import { SourceType } from './chats'
import { OrganizationId } from './idRegistry'

export type Organization = z.infer<typeof schemas.Organization>
export type QuillDashboard = z.infer<typeof schemas.QuillDashboard>

export type ListOrganizationsViewRequestData = z.infer<
  typeof schemas.ListOrganizationsViewRequestData
>
export type ListOrganizationsViewResponseData = z.infer<
  typeof schemas.ListOrganizationsViewResponseData
>

export type Organization0 = z.infer<typeof schemas.Organization0>
export type OrganizationQuerySettings = z.infer<typeof schemas.OrganizationQuerySettings>
export type OrganizationAISettings0 = z.infer<typeof schemas.OrganizationAISettings0>

export interface ICrawlTasksSort {
  by_field: 'crawled' | 'url'
  direction: 'asc' | 'desc'
}

export enum ScrapeStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  FINISHED = 'finished',
  FAILED = 'failed',
}

export interface ICrawlTask {
  id: string
  organization: string
  url: string
  crawl: boolean
  active: boolean
  sitemap: string | null
  status: ScrapeStatus
  cadence: string | null
  crawled: string | null
  next_crawl: string | null
  last_run_status?: ScrapeStatus
  last_run_time?: string | null
}

export interface IPagesFilter {
  organization?: OrganizationId | null
  prefix?: string
  not_prefix?: string
  query?: string
  source_type?: SourceType
  archived?: boolean
}

export interface IPagesSort {
  by_field: 'scraped' | 'title' | 'url'
  direction: 'asc' | 'desc'
}

export interface IPagesListArgs {
  filter: IPagesFilter
  sort: IPagesSort
  limit?: number
  offset?: number
}

export interface IPage {
  id: string
  organization: string
  url: string
  title: string
  external_link: boolean
  external_source: boolean
  scraped: string
  next_scrape: string
  archived: boolean
  gui_url: string | null
  tags?: string[]
}

export interface IPageEdit {
  page_id: string
  title?: string
  external_link?: boolean
  external_source?: boolean
  archived?: boolean
}
